module.exports = __webpack_public_path__ + "static/peter-thiel-42aff8175b44d19c18ec8ea5c1682fbb.jpg";